import React, { Component, PropTypes } from 'react';
// import ReactHighcharts from 'react-highcharts';

import config from './ChartBarConfig';
import { NitroLoading, NitroContentNotAvailable } from 'nitro-components';

import smplTheme from '../highcharts-themes/smpl';
import { getColour } from '../highcharts-themes/helper';

import Highcharts from 'highcharts';
import exporting from 'highcharts/modules/exporting';
import RHC from 'react-highcharts';

exporting(Highcharts);
const ReactHighcharts = RHC.withHighcharts(Highcharts);

class ChartBar extends Component {
  export = option => {
    const { data } = this.props;
    if (data.series[0].name) {
      const chart = this.refs.chart;
      this.props.exportDocument(chart.getChart().getSVG(), option);
    }
  };

  render() {
    const { data, plotOptions } = this.props;

    if (data) {
      const chartConfig = Object.assign({}, config, {
        series: data.series,
        xAxis: {
          categories: data.xAxis.categories,
        },

        plotOptions: plotOptions || {
          column: {
            stacking: 'normal',
          },
        },
        exporting: {
          sourceHeight: 720,
          sourceWidth: 1080,
          scale: 1.5,
          buttons: {
            contextButton: {
              enabled: false,
            },
          },
        },
      });

      // If data has yAxis
      if (data.yAxis && data.yAxis.length) {
        chartConfig.yAxis = [];
        data.yAxis.forEach(yAxis => {
          // Merge defaults from config with the yAxis data
          yAxis = Object.assign({}, config.yAxis, yAxis);
          chartConfig.yAxis.push(yAxis);
        });
      }

      const { id } = chartConfig;

      // Get all series that has data value greater than or less than 0;
      const seriesWithData = data.series.filter(series => {
        const seriesDataGtZero = series.data.filter(
          seriesData => seriesData !== 0
        );
        return seriesDataGtZero.length > 0;
      });

      if (!seriesWithData.length) {
        return <NitroContentNotAvailable />;
      }

      if (data.dataType === 'Currency') {
        chartConfig.tooltip.formatter = function() {
          const currency = parseFloat(this.y).toLocaleString('en-AU', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          return `<div>
              <b>${this.series.name} for ${this.x}</b><br />
              ${currency}
            </div>`;
        };
      } else {
        chartConfig.tooltip.formatter = function() {
          return `<div>
            <b>${this.series.name} for ${this.x}</b><br />
            ${this.y}
          </div>`;
        };
      }

      // Apply the theme
      Highcharts.theme = smplTheme;

      const newTheme = {
        ...smplTheme,
        colors: getColour(data.series.length),
      };

      Highcharts.setOptions(newTheme);

      return (
        <ReactHighcharts ref="chart" config={chartConfig} domProps={{ id }} />
      );
    } else {
      return <NitroLoading center thickness={2} size={24} />;
    }
  }
}

ChartBar.propTypes = {
  exportOptions: PropTypes.object,
  plotOptions: PropTypes.object,
  data: PropTypes.object.isRequired,
  error: PropTypes.bool, // TODO .isRequired
  exportDocument: PropTypes.func,
};

export default ChartBar;



// WEBPACK FOOTER //
// ./src/components/charts/chart-bar/ChartBar.js